module.exports = "/assets/data/9078c07bb3f51c4fdbaa27719dd48f37-LN3.data.json";